/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Tab_SubmitInputs */

const en_directory_submit_tab_submit = /** @type {(inputs: Directory_Submit_Tab_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a tool`)
};

const zh_directory_submit_tab_submit = /** @type {(inputs: Directory_Submit_Tab_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具`)
};

/**
* | output |
* | --- |
* | "Submit a tool" |
*
* @param {Directory_Submit_Tab_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_tab_submit = /** @type {((inputs?: Directory_Submit_Tab_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Tab_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_tab_submit(inputs)
	return zh_directory_submit_tab_submit(inputs)
});
export { directory_submit_tab_submit as "directory.submit.tab.submit" }